import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Dropdown, DropdownMenu, DropdownToggle, Row } from "reactstrap";
import SimpleBar from "simplebar-react";

import { SIGNALR_MESSAGE_TYPES } from "@/constants/signalrMessageTypes";

import {
  DoctorEnrollmentViewDetails,
  LetterOfAvailementsViewDetails, OrderRequestViewDetails,
  PatientEnrollmentViewDetails,
  PrescriptionRequestViewDetails
} from "@/pages/Globo/Transactions/TransactionsViewDetails";

import { AccessRequestViewDetails } from "@/pages/Security/TransactionsViewDetails";

import { useUnreadNotificationCount } from "@/context/unreadNotificationCountContext";

import useCustomHook from "../Hooks/useCustomHook";
import { useSignalRListener } from "../Hooks/useSignalRListener";
import NotificationData from "./NotificationData";

import { useCountUnReadNotificationsQuery, useReadAllNotificationsQuery, useReadNotificationsMutation } from "@/api/Endpoints/Core/Socials/Notifications";

const NOTIFICATION_TYPES = {
  CORE_TRANSACTIONS_ACCESSREQUESTS: "CORE_TRANSACTIONS_ACCESSREQUESTS",

  GLOBO_TRANSACTIONS_DOCTORENROLLMENTS: "GLOBO_TRANSACTIONS_DOCTORENROLLMENTS",
  GLOBO_TRANSACTIONS_PATIENTENROLLMENTS: "GLOBO_TRANSACTIONS_PATIENTENROLLMENTS",
  GLOBO_TRANSACTIONS_PRESCRIPTIONREQUESTS: "GLOBO_TRANSACTIONS_PRESCRIPTIONREQUESTS",
  GLOBO_TRANSACTIONS_LOAREQUESTS: "GLOBO_TRANSACTIONS_LOAREQUESTS",
  GLOBO_TRANSACTIONS_ORDERREQUESTS: "GLOBO_TRANSACTIONS_ORDERREQUESTS",
};

const NotificationDropdown = () => {
  const { state, customFunction } = useCustomHook();
  const [isNotificationDropdown, setIsNotificationDropdown] = useState(false);
  const [notificationId, setNotificationId] = useState(null);
  const { count, decrementCount, incrementCount, clearCount } = useUnreadNotificationCount();

  const { refetch } = useReadAllNotificationsQuery({}, { refetchOnMountOrArgChange: false });
  const [readNotification] = useReadNotificationsMutation();

  useEffect(() => {
    if (notificationId) {
      readNotification({ notificationId });
    }
  }, [notificationId, readNotification]);

  const { data } = useCountUnReadNotificationsQuery();

  const notificationCount = data?.returnData;
  const navigate = useNavigate();

  useSignalRListener({
    type: SIGNALR_MESSAGE_TYPES.NOTIFICATION,
    handler: () => {
      incrementCount()
    },
  });

  const toggleNotificationDropdown = (data) => {
    setIsNotificationDropdown(!isNotificationDropdown);
  };

  const handleClickNotification = (data) => {

    const notificationType = data.notificationType;
    setNotificationId(data?.notificationId)
    decrementCount()

    const toggleMap = {
      [NOTIFICATION_TYPES.CORE_TRANSACTIONS_ACCESSREQUESTS]: "toggleViewAccessRequest",

      [NOTIFICATION_TYPES.GLOBO_TRANSACTIONS_DOCTORENROLLMENTS]: "toggleViewDoctorEnrollments",
      [NOTIFICATION_TYPES.GLOBO_TRANSACTIONS_PATIENTENROLLMENTS]: "toggleViewPatientEnrollments",
      [NOTIFICATION_TYPES.GLOBO_TRANSACTIONS_PRESCRIPTIONREQUESTS]: "toggleViewPrescription",
      [NOTIFICATION_TYPES.GLOBO_TRANSACTIONS_LOAREQUESTS]: "toggleViewLetterOfAvailments",
      [NOTIFICATION_TYPES.GLOBO_TRANSACTIONS_ORDERREQUESTS]: "toggleViewOrderRequest",
    };

    if (toggleMap[notificationType]) return customFunction.updateToggle(toggleMap[notificationType], data);

  };

  const handleViewAllNotification = async () => {
    refetch()
    setIsNotificationDropdown(false)
    clearCount()
    navigate("/notifications");
  };
  return (
    <React.Fragment>

      {state.toggle.toggleViewAccessRequest && <AccessRequestViewDetails
        data={{ accessRequestId: state.trxValue?.referenceId }}
        show={state?.toggle?.toggleViewAccessRequest}
        onCloseClick={() => customFunction.updateToggle("toggleViewAccessRequest")}
        parentKey={1}
        onUpdateParentKey={() => { }}
      />}

      {state.toggle.toggleViewDoctorEnrollments && <DoctorEnrollmentViewDetails
        data={{ doctorEnrollmentId: state.trxValue?.referenceId }}
        show={state?.toggle?.toggleViewDoctorEnrollments}
        onCloseClick={() => customFunction.updateToggle("toggleViewDoctorEnrollments")}
        parentKey={1}
        onUpdateParentKey={() => { }}
      />}

      {state.toggle.toggleViewPatientEnrollments && <PatientEnrollmentViewDetails
        data={{ patientEnrollmentId: state.trxValue?.referenceId }}
        show={state?.toggle?.toggleViewPatientEnrollments}
        onCloseClick={() => customFunction.updateToggle("toggleViewPatientEnrollments")}
        parentKey={1}
        onUpdateParentKey={() => { }}
      />}

      {state.toggle.toggleViewPrescription && <PrescriptionRequestViewDetails
        data={{ prescriptionRequestId: state.trxValue?.referenceId }}
        show={state?.toggle?.toggleViewPrescription}
        onCloseClick={() => customFunction.updateToggle("toggleViewPrescription")}
        parentKey={1}
        onUpdateParentKey={() => { }}
      />}

      {state.toggle.toggleViewLetterOfAvailments && <LetterOfAvailementsViewDetails
        data={{ loaRequestId: state.trxValue?.referenceId }}
        show={state?.toggle?.toggleViewLetterOfAvailments}
        onCloseClick={() => customFunction.updateToggle("toggleViewLetterOfAvailments")}
        parentKey={1}
        onUpdateParentKey={() => { }}
      />}

      {state.toggle.toggleViewOrderRequest && <OrderRequestViewDetails
        data={{ orderRequestId: state.trxValue?.referenceId }}
        show={state?.toggle?.toggleViewOrderRequest}
        onCloseClick={() => customFunction.updateToggle("toggleViewOrderRequest")}
        parentKey={1}
        onUpdateParentKey={() => { }}
      />}

      <Dropdown isOpen={isNotificationDropdown} toggle={toggleNotificationDropdown} className="topbar-head-dropdown ms-1 header-item">
        <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
          <i className="bx bx-bell fs-22"></i>
          {count > 0 ? (
            <span className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">
              {count}
              <span className="visually-hidden">unread messages</span>
            </span>
          ) : null}
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
          <div className="dropdown-head bg-primary bg-pattern rounded-top">
            <div className="p-3">
              <Row className="align-items-center">
                <Col>
                  <h6 className="m-0 fs-16 fw-semibold text-white"> Notifications </h6>
                </Col>
                {count > 0 ? (
                  <div className="col-auto dropdown-tabs">
                    <span className="badge bg-danger text-white fs-13">{count}</span>
                  </div>
                ) : null}
              </Row>
            </div>
          </div>

          <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
            {isNotificationDropdown && <NotificationData onClickNotification={handleClickNotification} />}

            <div className="my-3 text-center">
              <button onClick={handleViewAllNotification} type="button" className="btn btn-soft-success waves-effect waves-light">
                View All Notifications <i className="ri-arrow-right-line align-middle"></i>
              </button>
            </div>
          </SimpleBar>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default NotificationDropdown;
